import { createContext } from 'react';
import type { UpdateAction, UpdateActionById } from 'state/formData';

export const UpdateActionContext = createContext<
  readonly [UpdateActionById, (key: string, action: UpdateAction) => void]
>([{}, () => undefined]);
